<template>
  <div>
    <!-- <svg t="1492500959545" @click="toggleClick" class="hamburger" :class="{'is-active':isActive}" style="" viewBox="0 0 1024 1024"
      version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1691" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64">
      <path d="M966.8023 568.849776 57.196677 568.849776c-31.397081 0-56.850799-25.452695-56.850799-56.850799l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 543.397081 998.200404 568.849776 966.8023 568.849776z"
        p-id="1692"></path>
      <path d="M966.8023 881.527125 57.196677 881.527125c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.849776 56.850799-56.849776l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.849776l0 0C1023.653099 856.07443 998.200404 881.527125 966.8023 881.527125z"
        p-id="1693"></path>
      <path d="M966.8023 256.17345 57.196677 256.17345c-31.397081 0-56.850799-25.452695-56.850799-56.849776l0 0c0-31.397081 25.452695-56.850799 56.850799-56.850799l909.605623 0c31.397081 0 56.849776 25.452695 56.849776 56.850799l0 0C1023.653099 230.720755 998.200404 256.17345 966.8023 256.17345z"
        p-id="1694"></path>
    </svg> -->
    <!-- <?xml version="1.0" encoding="UTF-8" standalone="no"?>
    <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"> -->
    <svg  t="1492500959545" @click="toggleClick" class="hamburger" :class="{'is-active':isActive}" style="" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="20px" height="20px" viewBox="0 0 20 20" enable-background="new 0 0 20 20" xml:space="preserve">
      <image id="image0" width="20" height="20" x="0" y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
    AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElN
    RQflBAEVJzu2QtvuAAAAoUlEQVQoz62RsQ3CUBBD34UgyAZMwhRIsAmiCh1tOhgEATUTMAob/KQy
    RfjRVxKRKzg3Lizf2WfCN3kkVunY8XNfpgNCCCqCiEB9qHW0EyV1YnAZ2S0oEUodxwD7L5sQZqyd
    sZlx9TiasDk3NtQqunp2gySP9tAFT1c9amzLPTF4DS+0+EIrFH5FMe+vM285bmEOtpqW6W0sCQ6h
    uVf/P/UHYlR56Hf5q80AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjEtMDQtMDFUMTM6Mzk6NTkrMDg6
    MDABSj1qAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIxLTA0LTAxVDEzOjM5OjU5KzA4OjAwcBeF1gAA
    ACB0RVh0c29mdHdhcmUAaHR0cHM6Ly9pbWFnZW1hZ2ljay5vcme8zx2dAAAAGHRFWHRUaHVtYjo6
    RG9jdW1lbnQ6OlBhZ2VzADGn/7svAAAAF3RFWHRUaHVtYjo6SW1hZ2U6OkhlaWdodAAyMN/hqJkA
    AAAWdEVYdFRodW1iOjpJbWFnZTo6V2lkdGgAMjAnTmgUAAAAGXRFWHRUaHVtYjo6TWltZXR5cGUA
    aW1hZ2UvcG5nP7JWTgAAABd0RVh0VGh1bWI6Ok1UaW1lADE2MTcyNTU1OTkXIV48AAAAEXRFWHRU
    aHVtYjo6U2l6ZQAyNDhCQkUca4sAAABGdEVYdFRodW1iOjpVUkkAZmlsZTovLy9hcHAvdG1wL2lt
    YWdlbGMvaW1ndmlldzJfOV8xNjA5OTAzNTMxNzk3MzQxNV83Nl9bMF0oer24AAAAAElFTkSuQmCC" ></image>
    </svg>

  </div>
</template>

<script>
export default {
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
}
</script>

<style scoped>
.hamburger {
	display: inline-block;
	cursor: pointer;
	width: 20px;
	height: 20px;
	transform: rotate(180deg);
	transition: .38s;
	transform-origin: 50% 50%;
}
.hamburger.is-active {
	transform: rotate(0deg);
}
</style>



// WEBPACK FOOTER //
// src/components/Hamburger/index.vue